import { Component, Input, OnInit } from '@angular/core';
import { Actions, ofType } from '@ngrx/effects';
import {
    DeleteCustomerNotifications,
    ECustomerMsisdnNotificationsActions
} from '../../store/actions/customer-msisdn-notifications.actions';
import { environment } from '../../../../../environments/environment';

@Component({
    selector: 'app-notif-bell',
    templateUrl: './notif-bell.component.html',
    styleUrls: ['./notif-bell.component.css'],
    standalone: false
})

export class NotifBellComponent implements OnInit {

    environment = environment;
    @Input()
    notificationsNumber: number;

    @Input()
    className: string = '';

    constructor(private action$: Actions) {}

    ngOnInit() {
        this.action$.pipe(ofType(ECustomerMsisdnNotificationsActions.DeleteCustomerNotifications)).subscribe((result: DeleteCustomerNotifications) => {
            if (result) {
                this.notificationsNumber = 0;
            }
        });
    }
}
